import React, { useState } from "react";
import TrainingCoursesTable from "./TrainingCoursesTable";
import EmployeeProgressTable from "./EmployeeProgressTable";
import CustomTabs from "components/tabs/customTab";
import { BookOpen, Users } from "lucide-react";

export default function TrainingProgramTabs() {
  const [activeTab, setActiveTab] = useState("training-courses");

  const tabOptions = [
    { 
      label: "Training Courses", 
      value: "training-courses",
      icon: <BookOpen />,
    },
    { label: "Employee Programs", 
      value: "employee-programs",
      icon: <Users />,
    },
  ];

  return (
    <div>

      <div className="w-full md:w-[400px]">
        <CustomTabs
          tabs={tabOptions}
          activeTab={activeTab}
          onChange={setActiveTab}
          height="h-10"
        />
      </div>

      <div className="mt-6">
        {activeTab === "training-courses" && (
          <TrainingCoursesTable/>
        )}
        {activeTab === "employee-programs" && (
          <EmployeeProgressTable/>
        )}
      </div>
    </div>
  );
}
